import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

export function CardContainer({ children, widgetMode = false, className }) {
    return (
        <div
            className={classNames(styles.root, className, {
                [styles.widgetPreview]: widgetMode,
            })}
        >
            {children}
        </div>
    );
}

CardContainer.propTypes = {
    children: PropTypes.node,
    widgetMode: PropTypes.bool,
    className: PropTypes.string,
};

CardContainer.defaultProps = {
    children: null,
    widgetMode: false,
    className: undefined,
};
